/**
 * 设计思路：
 * 1、level动态传入：默认5级
 * 2、areaCode动态传入：不传默认空
 * 3、根据areaCode获取不可选的区域的值；并且不可编辑
 * 3、必须选择上一级之后才能选择下一级;默认placehoder为已选择
 * 4、上一级改变时清空下面各级数据：（区域编码改变）
 * 5、选择完一级之后emit出去areaCode
 * 6、传入areaCode一传入的为准；不传入则从用户信息取；传入‘0’默认省可以选择
*/
import Service from './service';

export default {
  name: 'LocationSelect',
  data() {
    return {
      city_id: '',
      region: { // 各级的areaCode集合
        province: null,
        city: null,
        district: null,
        town: null,
        village: null
      },
      provinceList: [],
      cityList: [],
      districtList: [],
      townList: [],
      villageList: [],
      displayName: {},
      userInfoAreaCode: '',
      regionCode: '451022'
    };
  },
  props: {
    isShowProvince: {
      type: Boolean,
      default: true
    },
    currentAreaCode: {
      type: String,
      default: '451022'
    },
    disabledList: {
      type: Array,
      default() {
        return [false, false, false, false, false];
      }
    },
    level: {
      type: Number,
      default: 5
    },
    isForm: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 0
    }
  },
  created() {
    // this.$store.getters.currentUserRole.areaList.forEach((item) => {
    //   this.userInfoAreaCode += item;
    // });
    if (!this.currentAreaCode && !this.userInfoAreaCode) {
      this.userInfoAreaCode = this.regionCode;
    }

    if (this.currentAreaCode) {
      this.userInfoAreaCode = this.currentAreaCode;
    }

    this.getCityList(this.userInfoAreaCode.substring(0, 2));
    this.splitAreaCode(this.userInfoAreaCode);
    this.splitAreaCodeName();
  },
  watch: {
    currentAreaCode () {
      this.userInfoAreaCode = this.currentAreaCode;
      this.splitAreaCode(this.currentAreaCode);
      this.splitAreaCodeName();
    }
  },
  methods: {
    getDefaultCode() {
      let code = '22';
      if (this.currentAreaCode) {
        code = this.currentAreaCode;
      } else {
        code = this.regionCode;
      }
      return code;
    },
    /**
     * 清空
    */
    onReset() {
      this.districtList = [];
      this.townList = [];
      this.villageList = [];
      this.displayName = {};
      this.splitAreaCode(this.regionCode);
      this.splitAreaCodeName();
    },
    /**
     * 拆分各级areaCode
     */
    splitAreaCode(areaCode) {
      const length = areaCode && areaCode.length;
      if (!length) {
        return false;
      }
      // eslint-disable-next-line default-case
      switch (length) {
        case 2:
          this.region = {
            province: areaCode,
            city: null,
            district: null,
            town: null,
            village: null
          };
          break;
        case 4:
          this.region = {
            province: areaCode.slice(0, 2),
            city: areaCode,
            district: null,
            town: null,
            village: null
          };
          break;
        case 6:
          this.region = {
            province: areaCode.slice(0, 2),
            city: areaCode.slice(0, 4),
            district: areaCode,
            town: null,
            village: null
          };
          break;
        case 9:
          this.region = {
            province: areaCode.slice(0, 2),
            city: areaCode.slice(0, 4),
            district: areaCode.slice(0, 6),
            town: areaCode,
            village: null
          };
          break;
        case 12:
          this.region = {
            province: areaCode.slice(0, 2),
            city: areaCode.slice(0, 4),
            district: areaCode.slice(0, 6),
            town: areaCode.slice(0, 9),
            village: areaCode
          };
          break;
      }
    },

    // 根据传入的currentAreaCode获取各级
    splitAreaCodeName() {
      Object.keys(this.region).forEach(key => {
        if (this.region[key]) {
          // eslint-disable-next-line default-case
          switch (key) {
            case 'province':
              this.getCityList(this.region.province, false);
              break;
            case 'city':
              this.getDistrictList(this.region.city, false);
              break;
            case 'district':
              this.getTownList(this.region.district, false);
              break;
            case 'town':
              this.getVillageList(this.region.town, false);
              break;
            case 'village':
              this.selectVillageAction(this.region.village, false);
              break;
          }
        }
      });
    },

    /**
     * 1、上一级没有数据，下一集提示框显示：请选择上一级
     * 2、上一级有数据但是下一集没有数据提示：无数据
     */
    formateSelectDownValue(level) {
      const areaCodeArr = Object.values(this.region);
      if (areaCodeArr[level-1] && areaCodeArr[level-1].length) {
        document.querySelectorAll('.el-select-dropdown__empty').forEach((item) => {
          item.innerText = '暂无数据';
        });
      } else {
        document.querySelectorAll('.el-select-dropdown__empty').forEach((item) => {
          item.innerText = '请选择上一级';
        });
      }
    },

    /**
     * 当上一级区域code改变时清空所有下级区域的值；没有数据时下拉框为无数据
     */
    clearNextLevels(areaType, areaCode) {
      const currentIndex = Object.values(this.region).findIndex(v => v === areaCode);
      let index = 0;
      Object.keys(this.region).forEach((key) => {
        if (index > currentIndex) {
          this.region[key] === null;
        }
        index++;
      });
    },

    /**
     * 获取地区列表
     */
    getProvinceList(event, refreshNext = true) {
      // this.$emit('areaCodeChange', { areaCode: event }); // emit出areacode
      if (refreshNext) {
        this.splitAreaCode(event);
        this.cityList = [];
        this.districtList = [];
        this.townList = [];
        this.villageList = [];
      }
      Service.getLocationList(event).then(res => {
        if (res) this.provinceList = res.result;
      });
    },

    /**
     * 获取地区列表
     */
    getCityList(event, refreshNext = true) {
      let code = this.regionCode.substring(0, 2);
      if (code === '22') {
        this.displayName = {
          province: '吉林省'
        };
      } else if (code === '23') {
        this.displayName = {
          province: '黑龙江省'
        };
      } else if (code === '14') {
        this.displayName = {
          province: '山西省'
        };
      } else if (code === '51') {
        this.displayName = {
          province: '四川省'
        };
      } else if (code === '37') {
        this.displayName = {
          province: '山东省'
        };
      } else if (code === '65') {
        this.displayName = {
          province: '新疆维吾尔自治区'
        };
      } else if (code === '15') {
        this.displayName = {
          province: '内蒙古自治区'
        };
      }
      if (event.length !== 2) {
        this.$emit('areaCodeChange', { areaCode: event, displayName: this.displayName}); // emit出areacode
      }
      if (refreshNext) {
        this.splitAreaCode(event);
        this.districtList = [];
        this.townList = [];
        this.villageList = [];
      }
      Service.getLocationList(event).then(res => {
        if (res) this.cityList = res.result;
      });
    },

    /**
     * 获取地区列表
     */
    getDistrictList(event, refreshNext = true) {
      const item = this.cityList.find(item => item.id === event);
      this.displayName = {
        province: this.displayName.province,
        city: (item && item.name) || ''
      };
      this.$emit('areaCodeChange', { areaCode: event, displayName: this.displayName}); // emit出areacode
      if (refreshNext) {
        this.splitAreaCode(event);
        this.townList = [];
        this.villageList = [];
      }
      Service.getLocationList(event).then(res => {
        if (res) this.districtList = res.result;
      });
    },

    /**
     * 获取地区列表
     */
    getTownList(event, refreshNext = true) {
      const item = this.districtList.find(item => item.id === event);
      this.displayName = {
        province: this.displayName.province,
        city: this.displayName.city,
        district: (item && item.name) || ''
      };
      this.$emit('areaCodeChange', { areaCode: event, displayName: this.displayName}); // emit出areacode
      if (refreshNext) {
        this.splitAreaCode(event);
        this.villageList = [];
      }
      Service.getLocationList(event).then(res => {
        if (res) this.townList = res.result;
      });
    },

    /**
     * 获取地区列表
     */
    getVillageList(event, refreshNext = true) {
      const item = this.townList.find(item => item.id === event);
      this.displayName = {
        province: this.displayName.province,
        city: this.displayName.city,
        district: this.displayName.district,
        town: (item && item.name) || ''
      };
      // this.region.village = null;
      this.$emit('areaCodeChange', { areaCode: event, displayName: this.displayName}); // emit出areacode
      if (refreshNext) {
        this.splitAreaCode(event);
      }
      Service.getLocationList(event).then(res => {
        if (res) this.villageList = res.result;
      });
    },

    /**
     * 获取地区列表
     */
    selectVillageAction(event) {
      const item = this.villageList.find(item => item.id === event);
      this.displayName = {
        province: this.displayName.province,
        city: this.displayName.city,
        district: this.displayName.district,
        town: this.displayName.town,
        village: (item && item.name) || ''
      };
      this.$emit('areaCodeChange', { areaCode: event, displayName: this.displayName}); // emit出areacode
    },

    getRegionDisplay(code) {
      if (code.indexOf('22') === 0) {
        this.displayName = {
          province: '吉林省'
        };
      } else if (code.indexOf('23') === 0) {
        this.displayName = {
          province: '黑龙江省'
        };
      } else if (code.indexOf('14') === 0) {
        this.displayName = {
          province: '山西省'
        };
      } else if (code.indexOf('51') === 0) {
        this.displayName = {
          province: '四川省'
        };
      } else if (code.indexOf('37') === 0) {
        this.displayName = {
          province: '山东省'
        };
      } else if (code.indexOf('65') === 0) {
        this.displayName = {
          province: '新疆维吾尔自治区'
        };
      } else if (code.indexOf('15') === 0) {
        this.displayName = {
          province: '内蒙古自治区'
        };
      }
      if (code.length >= 4) {
        const target = this.getTarget(this.cityList, code.slice(0, 4));
        this.displayName.city = target.name;
      }
      if (code.length >= 6) {
        const target = this.getTarget(this.districtList, code.slice(0, 6));
        this.displayName.district = target.name;
      }
      if (code.length >= 9) {
        const target = this.getTarget(this.townList, code.slice(0, 9));
        this.displayName.town = target.name;
      }
      if (code.length >= 12) {
        const target = this.getTarget(this.villageList, code.slice(0, 12));
        this.displayName.village = target.name;
      }
      return this.displayName;
    },

    getTarget(list, code) {
      const target = list.find(item => item.id === code);
      return target || {};
    }
  }
};
